import tableAppCategories from './tableRelatedAppCategories';

export default {
  title: 'Categories',
  attributeName: 'appCategory',
  getURL: 'appId/areaId/appCategoryPlay',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['appId', 'areaId'],
  tableConfig: tableAppCategories,
};
